import React, { lazy } from 'react';
import { LazyComponent } from "seed/helpers";

const LatexBlock = lazy(() => import("components/util/render_util.lib.LatexBlock"));
const LatexInline = lazy(() => import("components/util/render_util.lib.LatexBlock"));


const renderHTML= (content) => {
  const latexRegex = /(\$\$(.+?)\$\$|\\\[.+?\\\]|\\\(.+?\\\)|\$(.+?)\$)/g;
  const segments = content.split(latexRegex).filter(Boolean);
  return segments.map((segment, index) => {
    if ((segment.startsWith('$$') && segment.endsWith('$$')) || (segment.startsWith('\\[') && segment.endsWith('\\]'))) {
      const expression = segment.slice(2, -2);
      return <LazyComponent key={index} math={expression} component={LatexBlock} />;
    }
    else if ((segment.startsWith('\\(') && segment.endsWith('\\)')) || (segment.startsWith('$') && segment.endsWith('$'))) {
      const expression = segment.slice(2, -2);
      return <LazyComponent key={index} math={expression} component={LatexInline} />;
    }
    else {
      const container = document.createElement('div');
      container.innerHTML = segment; 
      const elementsWithDataId = container.querySelectorAll('[data-id]');
      elementsWithDataId.forEach(el => {
        const textNode = document.createTextNode(el.getAttribute('data-id'));
        el.replaceWith(textNode);
      });
      
      let flattenedHTML = container.innerHTML;
      flattenedHTML = flattenedHTML.replace(/&gt;/g, '>').replace(/&lt;/g, '<');
      return <span key={index} dangerouslySetInnerHTML={{ __html: flattenedHTML }} />;
    }
  });

}

export { renderHTML };